import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { CategoryV2 } from './CategoryV2';

const mapStateToProps = (state, ownProps) => ({
  property: entitySelectors.getProperty(state),
  category: entitySelectors.getCategory(state, ownProps.id),
});

export const CategoryV2Container = connect(mapStateToProps)(CategoryV2);
